export default {
    props: {
        max_plate_length: {
            type: Number,
            default: 10
        },
    },
    mounted() {
    },
    created() {
    },
    methods: {
        plateRegEx(plate) {
            return plate.replace(/[^a-z0-9]/gi, '');
        },
        cleanPlateOnInput(plateValue) {
            if(plateValue === null){
                return null;
            }
            let plate = this.plateRegEx(plateValue);
            let uppercase = plate.toUpperCase();
            return uppercase.substring(0, this.max_plate_length);
        },
        watchInput(position, reference, plateModel) {
            let plateRecord = null,
                value = null,
                original = null;

            if (typeof plateModel === 'string') {
                plateRecord = plateModel;
                value = plateRecord;
                original = this.cleanPlateOnInput(plateRecord);
            }
            else if(typeof plateModel === 'object'){
                plateRecord = plateModel[position];
                value = plateRecord.new_value;

                original = this.cleanPlateOnInput(plateRecord.original_value);
            }
            else {
                plateRecord = plateModel[position];
                value = plateRecord.new_value;
                original = this.cleanPlateOnInput(plateRecord.original_value);
            }

            if (value !== original) {
                if (typeof this.$refs[reference + position] !== 'undefined') {
                    let inputReference = null;

                    if (typeof plateModel === 'string') {
                        inputReference = this.$refs[reference + position];
                    } else {
                        inputReference = this.$refs[reference + position][0];
                    }

                    let positionStart = inputReference.selectionStart,
                        endPosition = positionStart,
                        cleanPlate = this.cleanPlateOnInput(value),
                        changed = false;

                    if (typeof plateModel === 'string') {
                        this.plateModel = cleanPlate;
                    } else {
                        plateModel[position].new_value = cleanPlate;
                    }

                    if (cleanPlate.length < value.length) {
                        changed = true;
                        positionStart = positionStart - 1;
                        endPosition = positionStart;
                    }

                    this.$nextTick(() => {
                        inputReference.setSelectionRange(positionStart, endPosition);
                    });
                }
            }
        }
    },
};


// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/components/PlateFormatMixin.js